/**
 * Checkout payment session scope (IMP-06, GC-P1-04).
 */
import { createContext, useContext, useMemo, type ReactNode } from 'react';

export interface PaymentScope {
  readonly checkoutSessionPublicId: string | null;
  readonly paymentId: string | null;
}

const PaymentContext = createContext<PaymentScope | null>(null);

export function PaymentProvider({
  scope,
  children,
}: {
  readonly scope: PaymentScope;
  readonly children: ReactNode;
}): JSX.Element {
  const value = useMemo(() => scope, [scope]);
  return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>;
}

export function usePaymentScope(): PaymentScope | null {
  return useContext(PaymentContext);
}
